import React,{useState,useEffect,useRef}from 'react'
import { Table,Space,Modal,message,Form,Checkbox, Divider,} from 'antd';
import Main from '../cpn/Main';
import { MenuName } from '../cpn/MenuName';
import { useAllDeptUserSearchQuery, usePurviewSettingUpdateQuery, usePurviewSettingUpdateSaveMutation, } from '../store/ReactWebSiteApi';
import { useSearchParams } from 'react-router-dom';
function SetAppLimits() {
    const [param] = useSearchParams();
    const [form] = Form.useForm();  
    const appId = param.get('id');
    const appName = param.get('name')
    let menuLimits
    let handleLimits
    switch(appId){
        case'5'://培训
            menuLimits =    <Checkbox.Group onChange={(e) => {                                    
                                let removeArr = ['51', '52','53','54'];
                                const filteredArr = infoEdit.eu_menu_id.filter(item => !removeArr.includes(item))
                                let newArrId = filteredArr.concat(e);
                                setInfoEdit(prevState=>({...prevState,eu_menu_id:newArrId}))
                                }}>
                                <Checkbox value='51'>培训计划</Checkbox>
                                <Checkbox value='52'>我参加的</Checkbox>
                                <Checkbox value='53'>我负责的</Checkbox>
                                <Checkbox value='54'>设置</Checkbox>
                            </Checkbox.Group>
            handleLimits =  <Checkbox.Group>
                                <Space>                                        
                                    <Checkbox value='512'>修改培训计划</Checkbox>                                    
                                </Space>
                            </Checkbox.Group>
        break;
        
        default:
            console.log("I don't own a pet");
            break;
    }
    //修改权限-----------------------------------------------------------------------------------------------------------------------------修改权限
    const [editId,setEditId] = useState();
    const [infoEdit,setInfoEdit] = useState({
        eu_esv_id:['s'],
        eu_name:'',
    });
    const {data:dataLimit,isSuccess:isSuccessLimit} = usePurviewSettingUpdateQuery({eu_id:editId},{skip:!editId})
    useEffect(() => {
        if(isSuccessLimit){
            console.log(dataLimit);
            if(dataLimit.Result.eu_esv_id){
                if(dataLimit.Result.eu_esv_id.includes(appId)){
                    editForm.current.setFieldsValue({
                        eu_esv_id:appId,
                        eu_menu_id:dataLimit.Result.eu_menu_id,
                    })
                }
            }
            setInfoEdit(prevState=>({...prevState,
                eu_esv_id:dataLimit.Result.eu_esv_id,
                eu_esv_name:dataLimit.Result.eu_esv_name,
                eu_menu_id:dataLimit.Result.eu_menu_id,
                eu_menu_name:dataLimit.Result.eu_menu_name,
                eu_operate_id:dataLimit.Result.eu_operate_id,
                eu_operate_name:dataLimit.Result.eu_operate_name,
            }))
        }
    },[dataLimit,isSuccessLimit,appId])
    const [openEdit, setOpenEdit] = useState(false);
    const editForm = useRef()
    const [submitUpdateSave] = usePurviewSettingUpdateSaveMutation()
    
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        console.log(infoEdit.eu_esv_id);
        submitUpdateSave({
            eu_id:editId,
            // eu_esv_id:null,
            // eu_esv_name:null,
            // eu_menu_id:null,
            // eu_menu_name:null,
            // eu_operate_id:null,
            // eu_operate_name:null,
            eu_esv_id:infoEdit.eu_esv_id,
            eu_esv_name:infoEdit.eu_esv_name,
            eu_menu_id:infoEdit.eu_menu_id,
            eu_menu_name:infoEdit.eu_menu_name,
            eu_operate_id:infoEdit.eu_operate_id,
            eu_operate_name:infoEdit.eu_operate_name,
        }).then((res) => {
            console.log(res);
            if (res.data.Status === 'success') {
                message.success('修改成功！')   
                setOpenEdit(false)                             
            }
            if (res.data.Status === 'fail') {
                message.error(`修改失败!${res.data.Message}`)
            }
        })
        setOpenEdit(false);
    };
   
    const modalEdit = <Modal
                        open={openEdit}
                        width={800}
                        title={`请设置"${infoEdit.eu_name}"在"${param.get('name')}"的权限`}
                        okText="提交"
                        cancelText="取消"
                        onCancel={() => {setOpenEdit(false);}}
                        onOk={() => {
                            form
                                .validateFields()
                                .then((values) => {
                                    form.resetFields();
                                    onCreateEdit(values);
                                })
                                .catch((info) => {
                                    console.log('Validate Failed:', info);
                                });
                            
                        }}
                    >
                        <Form
                            form={form}
                            layout="horizonal"
                            name="form_client_edit"
                            initialValues={{modifier: 'public',}}
                            labelCol={{ span: 3 }}
                            ref={editForm}
                        >
                            <Divider >应用权限</Divider>
                            <Form.Item  wrapperCol={{span:21}} name='eu_esv_id' extra='勾选后，用户桌面显示应用图标。'>
                                <Checkbox.Group onChange={(e) => {                                    
                                    if(e.length===1){
                                        console.log(infoEdit.eu_esv_id)
                                        let newArrId = infoEdit.eu_esv_id;
                                        newArrId = [...newArrId,appId]
                                        
                                        let newArrName = infoEdit.eu_esv_name
                                        newArrName = [...newArrName,appName]
                                        setInfoEdit(prevState=>({...prevState,
                                            eu_esv_id:newArrId,
                                            eu_esv_name:newArrName,
                                        }))
                                    }else{
                                        setInfoEdit(prevState=>({...prevState,
                                            eu_esv_id:infoEdit.eu_esv_id.filter(item => item !== appId),
                                            eu_esv_name:infoEdit.eu_esv_name.filter(item => item !== appName),
                                        }))
                                    }
                                }}>
                                    <Checkbox value={appId}>允许使用</Checkbox>                                    
                                </Checkbox.Group>
                            </Form.Item>                         
                            <Divider >菜单权限</Divider>
                            <Form.Item wrapperCol={{span:21}}  extra='勾选后，用户显示相应菜单。' name='eu_menu_id'>
                                {menuLimits}
                            </Form.Item>
                            <Divider >操作权限</Divider>
                            <Form.Item wrapperCol={{span:21}}>
                                {handleLimits}
                            </Form.Item>
                        </Form>
                    </Modal>

    
    //普通用户列表-----------------------------------------------------------------------------------------------------------------------------普通用户列表
    
    const {data,isSuccess} = useAllDeptUserSearchQuery({e_id:localStorage.getItem('e_id'),eu_state:'1',action:'search'})
    
    const [list, setList] = useState();
    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                //console.log(data);
                
                const newArr = data.Result.map(item => {
                    const {eu_id:key,eu_name,eu_role,eu_esv_id,eu_menu_id,eu_ba_phone} = item;
                    return item = {key,eu_name,eu_role,eu_esv_id,eu_menu_id,eu_ba_phone}
                })
                // const filteredArray = newArr.filter(item => item.eu_role === '0');                                
                setList(newArr)
            }else{
                setList()
            }
            
        }
    }, [data, isSuccess])  
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },
        {
            key: 'type',
            title: '姓名',
            render:(_,record) => {
                return <>
                    <div>{record.eu_name}</div>
                    <div>{record.eu_ba_phone}</div>
                </>
            }
        },     
        {
            key: 'eu_esv_id',
            title: '应用权限',
            dataIndex: 'eu_esv_id',
            render:(text) => {
                if(text){
                    if(text.includes(param.get('id'))){
                        return <>允许使用</>
                    }else{
                        return <>禁止</>
                    }
                }else{
                    return <>禁止</>
                }
            }
        },                    
        {
            key: 'eu_menu_id',
            title: '菜单权限',
            dataIndex: 'eu_menu_id',
            render:(text) => {                
                if(text){
                    const newArr = MenuName.map((item) => {
                        if(text.includes(item.id)){
                            return <div>{item.name}</div>
                        }else{
                            return<></>
                        }                    
                    })
                    return newArr
                }else{
                    return <></>
                }          
            }
        },                    
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                if(record.ewptr_evaluate_uname){
                    return <>                   
                    <div>修改时间：{record.ewptr_evaluate_ctime + " " + record.ewptr_evaluate_uname.replace(/"/g,'')}</div>
                </>
                }
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space direction='vertical'>                        
                        <a onClick={() => {
                            setOpenEdit(true); 
                            setEditId(record.key);
                            setInfoEdit(prevState=>({...prevState,eu_name:record.eu_name}))                                                       
                        }}>修改</a>                   
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main t1='应用管理' t2={param.get('name')} t3='用户权限'>
            <Table columns={columns} dataSource={list}></Table> 
            {modalEdit}           
        </Main>
    )
}

export default SetAppLimits